export const DateTimeFormats = {
  TimeFormat12: 'hh mm a',
  TimeFormat13: 'hh:mm a',
  TimeFormatWithAm: 'hh:mm a',
  TimeFormat12Col: 'h:mm A',
  TimeFormat24: 'hh mm',
  TimeDisplayFormat: 'LT', // 4:49 PM
  DateDisplayFormat: 'ddd ll', //Thu Jan 20, 2022
  DateDisplayFormatFull: 'dddd ll', //Thu Jan 20, 2022
  EmailDateDisplayFormat: 'MMMM D, YYYY', //Thu Jan 20, 2022
  DateDisplayFormat2: 'MMM D', //Jan 20
  DateDisplayFormat3: 'MMM D, YYYY', //Jan 20, 2022
  DateDisplayFormatSuffix: 'MMM Do, YYYY', //Jan 20th, 2022
  DateTimeFormat: 'MMM D, y, h:mm a', // Feb 3 , 2022, 4:49 pm,
  DateTimeFormat1: 'MMM D, YYYY h:mm a', // Feb 3 , 2022, 4:49 pm,
  DateDisplayFormat4: 'MM/DD/yyyy', // 09/18/2022
  DateTimeFormat5: 'MM/DD/yyyy h:mm a', // 09/18/2022 4:49 pm
  DayName: 'dddd' // monday
}
